"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _InputFeedback = _interopRequireWildcard(require("../hocs/InputFeedback"));
var _Form = _interopRequireDefault(require("../hocs/Form"));
var _Icon = _interopRequireDefault(require("./Icon"));
var _utils = require("../../utils");
var _UIElementSizesEnum = require("../ts/enums/UIElementSizesEnum");
var _templateObject, _templateObject2;
const _excluded = ["name", "htmlType", "doNotShowFeedback", "styles", "containerStyles", "icon", "className"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const defaultProps = {
  htmlType: 'text',
  size: _UIElementSizesEnum.UIElementSizesEnum.Medium,
  doNotShowFeedback: false,
  withBorder: true,
  styles: '',
  icon: {
    position: 'left',
    name: '',
    onClick() {},
    size: 18,
    horizontalSpace: 0
  },
  containerStyles: '',
  width: '100%',
  className: ''
};
function InputComponent(props) {
  const _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
    {
      name,
      htmlType,
      doNotShowFeedback,
      styles,
      containerStyles,
      icon,
      className
    } = _defaultProps$props,
    restOfProps = _objectWithoutProperties(_defaultProps$props, _excluded);
  const {
    formState: {
      errors
    },
    register
  } = _Form.default.useForm();
  const fieldError = (0, _utils.getObjectField)(errors, name);
  const Container = (0, _react.useMemo)(() => doNotShowFeedback ? _InputFeedback.Wrapper : _InputFeedback.default, [doNotShowFeedback]);
  const buildIcon = (0, _react.useMemo)(() => {
    var _icon$name;
    return (icon === null || icon === void 0 || (_icon$name = icon.name) === null || _icon$name === void 0 ? void 0 : _icon$name.length) > 0 || /*#__PURE__*/_react.default.isValidElement(icon === null || icon === void 0 ? void 0 : icon.component);
  }, [icon === null || icon === void 0 ? void 0 : icon.component, icon]);
  return /*#__PURE__*/_react.default.createElement(Container, _extends({}, restOfProps, {
    errors: fieldError,
    hasError: Boolean(fieldError === null || fieldError === void 0 ? void 0 : fieldError.message),
    name: name,
    className: className,
    styles: containerStyles
  }), buildIcon && /*#__PURE__*/_react.default.createElement(IconContainer, {
    position: icon === null || icon === void 0 ? void 0 : icon.position,
    horizontalSpace: icon === null || icon === void 0 ? void 0 : icon.horizontalSpace
  }, /*#__PURE__*/_react.default.isValidElement(icon === null || icon === void 0 ? void 0 : icon.component) ? icon === null || icon === void 0 ? void 0 : icon.component : /*#__PURE__*/_react.default.createElement(_Icon.default, icon)), /*#__PURE__*/_react.default.createElement(Input, _extends({}, restOfProps, {
    id: name,
    buildIcon: buildIcon,
    iconPosition: icon === null || icon === void 0 ? void 0 : icon.position,
    iconHorizontalSpace: icon === null || icon === void 0 ? void 0 : icon.horizontalSpace,
    name: name,
    type: htmlType,
    hasError: Boolean(fieldError === null || fieldError === void 0 ? void 0 : fieldError.message),
    styles: styles
  }, register(name))));
}
const Input = _styled.default.input(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 7px;\n  padding: 0 12px;\n  font-family: 'Catamaran', sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 100;\n  font-style: normal;\n  font-size: 14px;\n\n  background-color: ", ";\n  opacity: ", ";\n\n  ", "\n\n  border: 1px solid\n    ", ";\n\n  ", "\n\n  ", "\n\n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    display: none;\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  ", "\n\n  ", "\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.colors.NEUTRAL.BACKGROUND;
}, _ref2 => {
  let {
    readOnly
  } = _ref2;
  return readOnly ? 0.65 : 1;
}, _ref3 => {
  let {
    disabled
  } = _ref3;
  return disabled && 'opacity: 0.7;';
}, _ref4 => {
  let {
    theme,
    withBorder
  } = _ref4;
  return withBorder ? theme.colors.NEUTRAL.SELECTED : theme.colors.NEUTRAL.TRANSPARENT;
}, _ref5 => {
  let {
    theme,
    hasError
  } = _ref5;
  return hasError && "border: 1px solid ".concat(theme.colors.MAIN.ERROR, ";");
}, _ref6 => {
  let {
    width
  } = _ref6;
  return width && "width: ".concat(width, ";");
}, _ref7 => {
  let {
    size,
    buildIcon,
    iconPosition = 'left',
    iconHorizontalSpace = 0
  } = _ref7;
  let styles = '';
  if (size === _UIElementSizesEnum.UIElementSizesEnum.Small) styles += 'height: 40px;';
  if (size === _UIElementSizesEnum.UIElementSizesEnum.Medium) styles += 'height: 45px;';
  if (size === _UIElementSizesEnum.UIElementSizesEnum.Large) styles += 'height: 50px;';
  if (buildIcon) {
    const totalSpace = iconHorizontalSpace + 30;
    if (iconPosition === 'left') styles += "padding-left: ".concat(totalSpace, "px;");
    if (iconPosition === 'right') styles += "padding-right: ".concat(totalSpace, "px;");
  }
  return styles;
}, _ref8 => {
  let {
    styles
  } = _ref8;
  return styles;
});
const IconContainer = _styled.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  position: absolute;\n  cursor: pointer;\n  padding: 10px;\n  top: 50%;\n  transform: translate(0, -50%);\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n\n  ", "\n"])), _ref9 => {
  let {
    position = 'left',
    horizontalSpace = 0
  } = _ref9;
  let styles = '';
  if (position === 'left') styles += "left: ".concat(horizontalSpace, "px;");
  if (position === 'right') styles += "right: ".concat(horizontalSpace, "px;");
  return styles;
});
var _default = exports.default = InputComponent;